import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EmailRequest } from '@features/termination/interfaces';

import { ConnectionContextService } from './connection-context.service';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private readonly http: HttpClient = inject(HttpClient);

  private readonly connectionContextService: ConnectionContextService =
    inject(ConnectionContextService);

  public sendEmail(terminationRequest: EmailRequest): Observable<void> {
    return this.http.post<void>(
      `/rgg/${this.connectionContextService.isConnected ? 'email2cs' : 'email2cs-nc'}/v1/emails/send`,
      terminationRequest,
    );
  }
}
